import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center justify-center w-10 h-10 text-xl text-gray-300 border border-gray-300 border-dashed rounded-full dark:text-gray-500 dark:border-gray-500" };
const _hoisted_2 = { class: "ml-3 text-sm italic" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'DrawerEndingButton',
    emits: ['click'],
    setup(__props, { emit }) {
        function handleClick() {
            emit('click');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: "flex items-center w-full h-16 text-gray-300 bg-gray-100 px-7 hover:bg-gray-200 dark:bg-gray-700 dark-hover:bg-gray-800 dark:text-gray-500 hover:text-gray-400 dark-hover:text-gray-400",
                onClick: handleClick
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "circle")
                ]),
                _createElementVNode("h1", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "text")
                ])
            ]));
        };
    }
});
